import { render, staticRenderFns } from "./brandSituation.vue?vue&type=template&id=6ad00350&scoped=true&"
import script from "./brandSituation.vue?vue&type=script&lang=js&"
export * from "./brandSituation.vue?vue&type=script&lang=js&"
import style0 from "./brandSituation.vue?vue&type=style&index=0&id=6ad00350&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad00350",
  null
  
)

export default component.exports